import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API_URL from "../../functions/config";

const UpdateEmployee = () => {

    const [name, setName] = React.useState('');
    const [empid, setEmpid] = React.useState('');
    const [emailid, setEmail] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [desigid, setDesigid] = React.useState('');
    const [compid, setCompid] = React.useState('');

    const [restrictTime, setRestrictTime] = React.useState('true');
    const [restrictLocation, setRestrictLocation] = React.useState('true');

    const [salary, setSalary] = React.useState('');
    const [salaryType, setSalaryType] = React.useState('Monthly');

    const [error, setError] = React.useState(false);
    const [success, setSuccess] = React.useState(false);

     const [errorMessage, setErrorMessage] = React.useState("");

    const auth = localStorage.getItem('user');
    const params = useParams();
    const navigate = useNavigate();

    const getEmployeeDetails = async () => {
       // console.warn(params);
        let result = await fetch(`${API_URL}/employee/${params.id}`, {
            headers: {
                authorization: `bearer ${JSON.parse(localStorage.getItem('token'))}`
            }
        });
        result = await result.json();
        setName(result.name)
        setEmpid(result.empid)
        setEmail(result.emailid)
        setPhone(result.phone)
        setDesigid(result.desigid)
        setCompid(result.compid)
        setSalary(result.salary)
        setSalaryType(result.salaryType)
        setRestrictTime(result.restrictTime)
        setRestrictLocation(result.restrictLocation)
    }



    if (compid !== JSON.parse(auth)._id) {
        navigate('/employees');
    } else { }


    useEffect(() => {
        getEmployeeDetails();
    }, []);


    const updateEmployee = async () => {

       // console.warn(name, empid, emailid, phone, desigid);

        let result = await fetch(`${API_URL}/employee/${params.id}`,
            {
                method: 'PUT',
                body: JSON.stringify({ name, empid, emailid, phone, desigid, restrictTime, restrictLocation, salary, salaryType}),
                headers: {
                    'Content-Type': 'application/json',
                    authorization: `bearer ${JSON.parse(localStorage.getItem('token'))}`
                },
            });

        result = await result.json();
        console.warn('NP Test', result);
        //  navigate('/');

           if(result.acknowledged===true){
            setSuccess(true);
           // navigate('/employees');
         }else if(result.success===false){
          
            setErrorMessage(
                result.message || "Employee could not be added."
            );

        }

        console.warn(!name);
        if (!name || !empid || !emailid || !phone || !desigid) {
            setError(true);
            return false;
        }

    }

    return (



        <div className="content">

            <main className="page-content p-4">

                <div className="card shadow-sm mb-4">

                    <div className="card-body">

                        <h2>Update Employee {name}</h2>

                        <p className="text-muted">
                            Choose a service to create your project.
                        </p>

                                                {errorMessage && (
    <div className="alert alert-danger mt-3">
        {errorMessage}
    </div>
)}

                        {success &&
                            <div className="alert alert-success" role="alert">
                                <strong>Great!</strong> Your Employee Updated successfully.
                            </div>
                        }
                        <div className="row justify-content-center g-4">

                            <div className="col-lg-6">
                                <input className='form-control' type='text' onChange={(e) => setName(e.target.value)} value={name} placeholder='Enter Employee Name' />
                                {error && !name && <span className="error_msg">Please Fill Product Name</span>}
                            </div>

                            <div className="col-lg-6">
                                <input className='form-control' type='text' onChange={(e) => setEmpid(e.target.value)} value={empid} placeholder='Enter Employee ID Like (TS001)' />
                                {error && !empid && <span className="error_msg">Please Fill Employee ID</span>}
                            </div>

                            <div className="col-lg-6">
                                <input className='form-control' type='text' onChange={(e) => setEmail(e.target.value)} value={emailid} placeholder='Enter Employee Email Id' />
                                {error && !emailid && <span className="error_msg">Please Fill Email ID</span>}
                            </div>

                            <div className="col-lg-6">
                                <input className='form-control' type='text' onChange={(e) => setPhone(e.target.value)} value={phone} placeholder='Enter Employee Phone Number' />
                                {error && !phone && <span className="error_msg">Please Fill Employee phone</span>}
                            </div>

                            <div className="col-lg-6">
                                <select value={desigid} className='form-control' onChange={(e) => setDesigid(e.target.value)}>
                                    <option value={''}>Select One</option>
                                    <option value={1}>Management</option>
                                    <option value={2}>Finance & Accounts</option>
                                    <option value={3}>Technical</option>
                                    <option value={4}>Oprational</option>
                                    <option value={5}>Legal Department</option>
                                    <option value={6}>Sales & Marketing</option>
                                    <option value={7}>Others</option>
                                </select>
                                {error && !desigid && <span className="error_msg">Please Select Department</span>}
                            </div>
<hr></hr>

                             <div className="col-lg-6">
                                <label>Restrict on Time</label>
                                <select value={restrictTime} className='form-control' onChange={(e) => setRestrictTime(e.target.value)}>
                                    <option value={true}>Yes</option>
                                    <option value={false}>No</option>
                                </select>
                            </div>

                            <div className="col-lg-6">
                                <label>Restrict on Location</label>
                                <select value={restrictLocation} className='form-control' onChange={(e) => setRestrictLocation(e.target.value)}>
                                    <option value={true}>Yes</option>
                                    <option value={false}>No</option>
                                </select>
                            </div>

                               <div className="col-lg-6">
                                <label>Salary Paid</label>
                                <select value={salaryType} className='form-control' onChange={(e) => setSalaryType(e.target.value)}>
                                    <option value={'Monthly'}>Monthly</option>
                                    <option value={'Hourly'}>Hourly</option>
                                </select>
                            </div>


                               <div className="col-lg-6">
                               {salaryType === "Monthly"
            ? "Monthly Salary ?"
            : "Per Hour ?"}
                            <input className='form-control' type='number' onChange={(e) => setSalary(e.target.value)} value={salary} placeholder='Enter Amount' />
                            {error && !salary && <span className="error_msg">Please Fill Amount</span>}
                            </div>




                            <div className="col-lg-12 text-center">
                                <button type='button' onClick={updateEmployee} className='btn btn-success'>Update Employee</button>
                            </div>

                        </div>



                    </div>

                </div>



            </main>

        </div>

    )

}


export default UpdateEmployee;

